import { type CustomizationKey } from './customization_demo_catalog'

// toolkit-spa writes `null` for a customization it turned off, so a selection is off when it is
// missing, empty or null; read it through the store's `demoProfileFor`.
export type DemoSelections = Partial<Record<CustomizationKey, string | null>>

// The two SPAs are served from the same origin, so sharing this key is what lets this modal report
// a demo that was turned on in toolkit-spa. Session storage scopes that to the presenter's tab and
// clears itself when the tab closes, so a demo can never leak into a later session. The key must
// match toolkit-spa's customizationdemo.storage.js.
export const DEMO_STORAGE_KEY = 'goalbook.customizationDemo.selections'

export const readStoredSelections = (): DemoSelections => {
  try {
    const stored = window.sessionStorage.getItem(DEMO_STORAGE_KEY)
    const parsed = stored ? JSON.parse(stored) : null
    return parsed && typeof parsed === 'object' ? (parsed as DemoSelections) : {}
  } catch {
    return {}
  }
}

export const writeStoredSelections = (selections: DemoSelections): void => {
  try {
    window.sessionStorage.setItem(DEMO_STORAGE_KEY, JSON.stringify(selections))
  } catch {
    // A presenter with storage blocked still sees the modal, just not which demos are on.
  }
}
